export const PAYMENT_RUN_STATUS = {
  READY: 'ready',
  FEE_CAP: 'fee cap',
  CARD_CHARGED: 'card charged',
  ACH_CHARGED: 'ach charged',
  PROCESSING: 'processing',
  DROPPED: 'dropped',
  DUPLICATE: 'duplicate',
  SUPERSEDED: 'superseded',
  FAILED: 'failed',
  CHARGE_FAILED: 'charge failed',
} as const;

export type FilterTab =
  | 'all'
  | 'ready'
  | 'flagged'
  | 'removed'
  | 'failed'
  | 'successfulCharge';

export const PAYMENT_RUN_TIMEZONE = 'America/New_York';
export const POSTPONE_HOURS = 24;
export const POSTPONE_MAX_PER_CYCLE = 2;
/** 10:00 AM ET — next scheduled run hour */
export const PAYMENT_RUN_HOUR = 10;

export const LOCK_CHECKBOX_CLASS_NAME =
  'border-amber-500 data-[state=checked]:bg-amber-500 data-[state=checked]:text-white data-[state=checked]:border-amber-500';
